/* eslint-disable no-param-reassign */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
// @mui material components
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";
import dayjs from "dayjs";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// custom styles for the NotificationItem
import menuItem from "components/Items/NotificationItem/styles";
import colors from "assets/theme/base/colors";
import MDBadgeDot from "components/MDBadgeDot";
import Marquee from "components/Marquee";
import { Icon } from "@mui/material";

const relativeTime = require("dayjs/plugin/relativeTime");

dayjs.extend(relativeTime);

// eslint-disable-next-line react/display-name
const NotificationItem = forwardRef(
  ({ markRead, icon, title, id, hasSeen, time, ...rest }, ref) => {
    const ago = dayjs(dayjs.unix(time)).fromNow();

    const markReadFn = async (e) => {
      e.stopPropagation();
      markRead(id);
    };
    return (
      <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
        <MDBox component={Link} py={0.5} display="flex" alignItems="center" lineHeight={1}>
          <MDTypography
            variant="body1"
            style={{ color: !hasSeen ? colors.dark.main : colors.grey[400] }}
            lineHeight={0.75}
          >
            <Icon style={{ color: !hasSeen ? colors.dark.main : colors.grey[400] }}>{icon}</Icon>
          </MDTypography>
          <MDBox
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            style={{ minWidth: 200 }}
            pl={1}
          >
            <Marquee
              text={title}
              height={22}
              width={200}
              fontWeight="normal"
              underlineOnHover={false}
              style={{ color: !hasSeen ? colors.dark.main : colors.grey[400] }}
              fontSize={13}
            />
            <MDBox
              display="flex"
              flexDirection="row"
              alignItems="space-between"
              style={{ width: "1%" }}
            >
              <MDTypography
                variant="caption"
                style={{ color: !hasSeen ? colors.primary.main : colors.grey[400], fontSize: 11 }}
                textAlign="right"
              >
                {ago}
              </MDTypography>
              <MDBox ml={2}>
                <MDTypography
                  variant="caption"
                  style={{ color: !hasSeen ? colors.grey[500] : colors.grey[400], fontSize: 11 }}
                  textAlign="right"
                >
                  {dayjs.unix(time).format("MMM DD, hh:mm A")}
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
          {!hasSeen && (
            <MDBox pl={2}>
              <Tooltip title="Mark reads" enterDelay={500}>
                <MDBadgeDot size="md" color="info" font={{ color: "text" }} onClick={markReadFn} />
              </Tooltip>
            </MDBox>
          )}
        </MDBox>
      </MenuItem>
    );
  }
);

// Typechecking props for the NotificationItem
NotificationItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default NotificationItem;
